import React from 'react';

import Arrow from '@swf/core/assets/icons/arrow.svg';
import { ListItem } from '@swf/first';

import { arrowContainer, cluster, clusterText } from './ClusterResult.scss';

interface Props {
  text: string;
  description: string;
}

const ClusterResult: React.FC<Props> = ({ text, description }) => (
  <ListItem
    primary={
      <span>
        <strong>{text}</strong> (
        {description.slice(description.lastIndexOf('-') + 1).replace(/^[\s]+/, '')})
      </span>
    }
    classes={{
      button: cluster,
      avatarContainer: arrowContainer,
      primaryText: clusterText
    }}
    avatar={<Arrow />}
  />
);

export default ClusterResult;
